import { createContext } from 'react';
import {
	TLanguageIDs,
	IDataGetRestaurantInfo,
	ILatestSoftwareUpdateInfo,
	IRestaurantLocalizationInfo,
	IRestaurantStylesInfo,
	IRestaurantReportsInfo,
	IRestaurantAndroidWatchesMessagesData,
} from 'types';

export type TRestaurantFullInfoVisibleForm =
	| 'mainForm'
	| 'localizationForm'
	| 'styleForm'
	| 'softwareForm'
	| 'devicesForm'
	| 'additionallyForm'
	| 'watchesForm'
	| 'reportsForm'
	| 'bankSettingsForm'
	| 'androidWatchesForm';
export type TSelectedLocalizationItem = { id: Nullable<string>; name: Nullable<string> };
export interface ISelectedStyleGroup {
	id: string;
	key: string;
}

export interface IRestaurantFullInfoState {
	restaurantFullInfoVisibleForm: TRestaurantFullInfoVisibleForm;
	restaurantForFullInfo: Nullable<IDataGetRestaurantInfo>;
	selectedLocalizationGroup: Nullable<TSelectedLocalizationItem>;
	selectedLocalizationLanguage: Nullable<TSelectedLocalizationItem>;
	localizationData: Nullable<IRestaurantLocalizationInfo>;
	styleData: Nullable<IRestaurantStylesInfo>;
	selectedStyleGroup: Nullable<ISelectedStyleGroup>;
	selectedStyleLanguage: Nullable<TLanguageIDs>;
	latestSoftwareUpdateData: Nullable<ILatestSoftwareUpdateInfo>;
	report: Nullable<IRestaurantReportsInfo>;
	androidWatches: Nullable<IRestaurantAndroidWatchesMessagesData>;
}

export const restaurantFullInfoInitialState: IRestaurantFullInfoState = {
	restaurantFullInfoVisibleForm: 'mainForm',
	restaurantForFullInfo: null,
	selectedLocalizationLanguage: null,
	selectedLocalizationGroup: null,
	localizationData: null,
	styleData: null,
	selectedStyleGroup: null,
	selectedStyleLanguage: null,
	latestSoftwareUpdateData: null,
	report: null,
	androidWatches: null,
};

export interface IRestaurantFullInfoContext extends IRestaurantFullInfoState {
	changeRestaurantFullInfoVisibleForm(value: TRestaurantFullInfoVisibleForm): void;
	setLocalizationGroup(value: Nullable<TSelectedLocalizationItem>): void;
	setLocalizationLanguage(value: Nullable<TSelectedLocalizationItem>): void;
	setStyleGroup(value: Nullable<ISelectedStyleGroup>): void;
	setStyleLanguage(value: TLanguageIDs): void;
}

export const RestaurantFullInfoContext = createContext<IRestaurantFullInfoContext>({
	changeRestaurantFullInfoVisibleForm: () => undefined,
	setLocalizationGroup: () => undefined,
	setLocalizationLanguage: () => undefined,
	setStyleGroup: () => undefined,
	setStyleLanguage: () => undefined,
	...restaurantFullInfoInitialState,
});
